<template>
  <div>
    <span>并行任务（同时进行）</span>
  </div>
</template>

<script>
import DeptPicker from '@/components/common/DeptPicker'
import OrgItems from '../OrgItems'

export default {
  name: 'CcNodeConfigVue',
  components: { DeptPicker, OrgItems },
  props: {
    config: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    select: {
      get () {
        return this.config.assignedUser || []
      },
      set (val) {
        this.config.assignedUser = val
      }
    }
  },
  data () {
    return {
      visible: false,
      pickerTitle: '选择',
      orgPickerType: 'user'
    }
  },
  methods: {
    selectOrg () {
      // this.$refs.orgPicker.show()
      this.pickerTitle = '选择抄送人'
      this.orgPickerType = 'user'
      this.visible = true
    },
    selected (select) {
      console.log(select)
      this.visible = false
      this.select = Object.assign([], select)
    },
    close () {
      this.visible = false
    },
    removeOrgItem (index) {
      this.select.splice(index, 1)
    }
  }
}
</script>

<style lang="less" scoped>
.option{
  color: #606266;
  margin-top: 20px;
  font-size: small;
}

.desc{
  font-size: small;
  color: #8c8c8c;
}
.org-item{
  margin: 5px;
}
</style>
